<template>
  <section class="pt-2 pb-6 py-5 md:mx-8 mx-4">
    <card-with-header-and-footer-component :loading="false">
      <template v-slot:header>
        <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:truncate">{{ $t('projects.general') }}</h3>
      </template>

      <!-- Ficha editable con la API V2 de cursos (FE-041, backend LMS-050/052/054). -->
      <course-details-form v-if="courseFeatures.editCourse && projectsStore.project.uuid"
                           :course-uuid="projectsStore.project.uuid" @saved="onCourseSaved"></course-details-form>

      <!--
        Sin el backend de la ficha (flag VUE_APP_LMS_EDIT_COURSE apagado) la información se
        muestra en solo lectura: PUT /project es un stub y no existe el borrado.
      -->
      <template v-else-if="!courseFeatures.editCourse">
        <dl class="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div class="sm:col-span-2">
            <dt class="text-sm font-medium text-gray-500">{{ $t('general.title') }}</dt>
            <dd class="mt-1 text-sm text-gray-900">{{ projectsStore.project.title }}</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-gray-500">{{ $t('projects.status_label') }}</dt>
            <dd class="mt-1">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    :class="projectsStore.project.status === 'publish' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'">
                {{ statusLabel }}
              </span>
            </dd>
          </div>
        </dl>

        <p class="mt-6 rounded-md bg-blue-50 border border-blue-200 px-4 py-3 text-sm text-blue-800">
          {{ $t('projects.general_editing_coming_soon') }}
        </p>
      </template>
    </card-with-header-and-footer-component>

    <!-- Zona de peligro: borrado con protección (FE-042, backend LMS-056). -->
    <div v-if="courseFeatures.deleteCourse && projectsStore.project.uuid"
         class="mt-6 rounded-md bg-white shadow border border-red-200 px-4 py-5 sm:p-6 sm:flex sm:items-center sm:justify-between gap-4">
      <div>
        <h3 class="text-base font-semibold text-red-700">{{ $t('projects.delete_course') }}</h3>
        <p class="mt-1 text-sm text-gray-500">{{ $t('projects.delete_course_help') }}</p>
      </div>
      <button type="button" v-on:click="showDeleteModal = true"
              class="mt-4 sm:mt-0 flex-shrink-0 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
        {{ $t('projects.delete_course') }}
      </button>
    </div>

    <delete-course-modal v-if="showDeleteModal" :course="projectsStore.project"
                         @close="showDeleteModal = false" @deleted="onCourseDeleted"></delete-course-modal>
  </section>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import CourseDetailsForm from "@/views/projects/ProjectEdit/CourseDetailsForm";
import DeleteCourseModal from "@/views/projects/ProjectEdit/DeleteCourseModal";
import courseFeatures from "@/config/courseFeatures";
import {useProjectsStore} from "@/stores/projects";

export default {
  name: "ProjectGeneralComponent",
  components: {CardWithHeaderAndFooterComponent, CourseDetailsForm, DeleteCourseModal},
  setup() {
    const projectsStore = useProjectsStore()

    return {
      projectsStore
    }
  },
  data() {
    return {
      courseFeatures,
      showDeleteModal: false,
    }
  },
  computed: {
    statusLabel() {
      const labels = {
        publish: this.$t('projects.published'),
        draft: this.$t('projects.draft'),
        private: this.$t('projects.private'),
        archived: this.$t('projects.archived'),
      }
      return labels[this.projectsStore.project.status] ?? this.projectsStore.project.status
    }
  },
  methods: {
    // Mantiene sincronizados la cabecera y el resto de pestañas sin recargar el proyecto.
    onCourseSaved(course) {
      this.projectsStore.project.title = course.title
      this.projectsStore.project.status = course.status
    },
    onCourseDeleted() {
      this.showDeleteModal = false
      this.$router.push({ name: 'projects-list' })
    }
  }
}
</script>
